import React from 'react';

import { ToolbarOption } from '../../toolbar-option';
import { useSummarizationControlProps } from './use-summarization-control-props';

export function SummarizationOption() {
    const controlsProps = useSummarizationControlProps();

    const { onMouseEnter, onMouseLeave, ...props } = controlsProps;

    return (
        <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <ToolbarOption {...props} content={props.title} />
        </div>
    );
}
